<template>
  <div>
    <brand-top-banner />
    <!-- <barnd-trade-data /> -->
    <!-- <feature-panel /> -->
    <mission-panel :customStyle="missionCustomStyle" />
    <honor-panel />
    <about-panel />
  </div>
</template>
<script>
import BrandTopBanner from "@/components/home/brand-top-banner.vue";
import HonorPanel from "@/components/home/honor-panel.vue";
// import FeaturePanel from "@/components/home/feature-panel.vue";
// import MissionPanel from "@/components/home/mission-panel.vue";
import MissionPanel from "@/components/home/mission-panel-new.vue";
import AboutPanel from "@/components/home/about-panel-new.vue";
import { mapGetters } from "vuex";
// import BarndTradeData from "@/components/home/barnd-trade-data.vue";
export default {
  props: {},
  components: {
    BrandTopBanner,
    HonorPanel,
    // FeaturePanel,
    MissionPanel,
    AboutPanel,
    // BarndTradeData,
  },
  mixins: [],
  data() {
    return {
      missionCustomStyle: {},
    };
  },
  async created() {
    this.missionCustomStyle = this.getMissionCustomStyle(false);
  },
  destroyed() {},
  beforeDestroy() {},
  watch: {
    isDarkMode() {
      this.missionCustomStyle = this.getMissionCustomStyle(false);
    },
  },
  computed: {
    ...mapGetters({
      isDarkMode: "user/isDarkMode",
    }),
  },
  methods: {
    getMissionCustomStyle(isLight) {
      return {
        ...this.getBgColor(isLight),
        paddingTop: "50px",
      };
    },
    getBgColor(isLight) {
      const rootElement = document.documentElement;
      const computedStyle = getComputedStyle(rootElement);
      const homeBgLightColor =
        computedStyle.getPropertyValue("--homeBgLightColor");
      const homeBgColor = computedStyle.getPropertyValue("--homeBgColor");
      return {
        backgroundColor: isLight ? homeBgLightColor : homeBgColor,
      };
    },
  },
};
</script>
<style lang="scss">
</style>
